import { render } from "./TheKhomAp.vue?vue&type=template&id=733c5995"
import script from "./TheKhomAp.vue?vue&type=script&lang=js"
export * from "./TheKhomAp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__